import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { SettingsCard } from '../../components/composed';
import { useAuth } from '../../contexts/AuthContext';

// Date formatting utility function
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

// Date time formatting utility function
const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

const OrganizationSettings = () => {
  const { organization, loading } = useAuth();

  if (loading || !organization) {
    return (
      <SettingsCard title="Organization Settings">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Loading organization information...
          </Typography>
        </Box>
      </SettingsCard>
    );
  }

  return (
    <SettingsCard title="Organization Settings">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Name */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Name
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {organization.name || 'N/A'}
              </Typography>
            </Box>

            {/* Description */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Description
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {organization.description || 'N/A'}
              </Typography>
            </Box>

            {/* Created At */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Created At
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDate(organization.created_at)}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Updated At */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Last Updated
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDateTime(organization.updated_at)}
              </Typography>
            </Box>

            {/* Is Active */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Active Status
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {organization.is_active ? 'Active' : 'Inactive'}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default OrganizationSettings;
